import number from 'num';

export default class NumberUtil {
    isNumeric(number) {
        return isNumeric(number);
    }

    isInteger(number) {
        return parseInt(number) === number;
    }

    numberify(value) {
        value = `${value} `;
        return parseFloat(value.replace(/[^\d.-]/g, ''));
    }

    convertToPercentage(percent) {
        return Math.min(Math.max(percent, 0), 100);
    }
}

export function isNumeric(number) {
    return !isNaN(parseFloat(number)) && isFinite(number);
}

const abbreviations = [
    { symbol: 'Q', limit: 1e15 },
    { symbol: 'T', limit: 1e12 },
    { symbol: 'B', limit: 1e9 },
    { symbol: 'M', limit: 1e6 },
    { symbol: 'K', limit: 1e3 }
];

export function prettifyNumber(value, options) {
    value = Number(value);
    options = options || {};
    options.decimals = options.decimals == null
        ? 2
        : options.decimals;

    if (!options.preventShrink && (options.limit == null || isValueOutsideTheLimit(value, options.limit))) {
        for (let index = 0; index < abbreviations.length; ++index) {
            let abbreviation = abbreviations[index];
            if (value <= -abbreviation.limit || abbreviation.limit <= value) {
                // it's a very large number
                return isValueOutsideTheLimit(value / abbreviation.limit, 10000) && index === 0
                    ? formatValue(toExponential(value / abbreviation.limit, 0), '', options)
                    : formatValue(toFixed(value / abbreviation.limit, options.decimals), abbreviation.symbol, options);
            }
        }
    }

    return formatValue(toFixed(value, options.decimals), '', options);
}

export function localizeNumber(value, decimals) {
    return value.toLocaleString([], {
        minimumFractionDigits: decimals || 0
    });
}

function isValueOutsideTheLimit(value, limit) {
    return value < -limit || value > limit;
}

function formatValue(value, symbol, options = {}) {
    if (value > 0 && options.addPositiveSign) {
        value = `+${prettify(value, options)}`;
    } else if (value < 0 && options.omitNegativeSign) {
        value = prettify(Math.abs(value, options));
    } else {
        value = prettify(value, options);
    }

    return `${value}${symbol}`;
}

function prettify(value, options = {}) {
    return options.pretty
        ? localizeNumber(+value, options.decimals)
        : value;
}

// use custom toFixed instead of built-in Number.prototype.toFixed:
// - to prevent rounding up/down (e.g. -999.999 -> -1000)
// - to prevent floating point math (e.g. 8.95 * 100 -> 894.9999999999999)
export function toFixed(value, decimals) {
    // since negative numbers are still not rounded properly (e.g. -4,076.9700000003 -> -4,076.98 instead of -4,076.97),
    // workaround the sign with this sorcery
    let absolute = Math.abs(value);
    let sign = value < 0
        ? '-'
        : '';

    return sign + number(absolute).set_precision(decimals || 0).toString();
}

function toExponential(value, decimals) {
    return Number.prototype.toExponential.call(value || 0, decimals);
}



// WEBPACK FOOTER //
// ./src/application/util/number.util.js